import LazyLoad from 'vanilla-lazyload';

import app_data from '../../globali/get-app-data';
import sharing_links from '@massimo-cassandro/sharing-links/sharing-links';
import {email_antispam} from '@massimo-cassandro/m-utilities/js-utilities/email-antispam';

import menu_trigger from './menu-trigger';
import menu_utente_trigger from './menu-utente-trigger';
import analytics_e_cookie_manager from './analitycs-e-cookie-manager';


export default function start() {

  // browser check
  // if(!inputDateSupport() || !inputTimeSupport() || isIE()) {
  //   document.getElementById('content').insertAdjacentHTML('beforebegin',
  //     `<div class="alert alert-icon alert-danger" role="alert">
  //       <h1 class="h2 mb-2">Stai utilizzando un browser non adatto</h1>
  //       <p>Stai utilizzando un browser che non supporta tutte le tecnologie utilizzate in questo sito
  //       e qualcosa potrebbe non funzionare correttamente.<br>
  //       È consigliabile utilizzarne uno più moderno.</p>
  //     </div>`
  //   );
  // }

  analytics_e_cookie_manager();

  let start_params = {};

  // necessario in tutte le pagine per i banner
  start_params.lazyload = new LazyLoad({
    elements_selector: '[loading=lazy]',
    use_native: true // ← enables hybrid lazy loading
  });


  sharing_links({
    sharing: ['fb', 'twt', 'lnkd', 'wa'],
    size: 'std',
    title: 'Condividi con [[NAME]]',
    share_icon: false
  });

  menu_trigger();
  menu_utente_trigger();

  // hidden emails
  email_antispam({default_domain: app_data.domain });

  // dismiss alert
  // document.querySelectorAll('[data-bs-dismiss]').forEach(item => {
  //   item.addEventListener('click', () => {
  //     item.closest('.' + item.dataset.bsDismiss).remove();
  //   }, false);
  // });

  // alert autoclose
  // let flash_alert = document.querySelector('.alert-success.alert-flash');
  // if(flash_alert) {
  //   window.setTimeout(function () {
  //     slideUp(flash_alert, 500, () => {
  //       flash_alert.remove();
  //     });
  //   }, 4000);
  // }


  //page is loaded
  document.documentElement.classList.add('page-is-loaded');

  return start_params;
}
